import Lottie from "lottie-react";
import loaderAnimation from "../../assets/loader.json"; // adjust path as needed

export default function Loader() {
  return (
    <div className="min-h-screen flex justify-center items-center">
      <div className="w-48 h-48">
        <Lottie animationData={loaderAnimation} loop autoplay />
      </div>
    </div>
  );
}
